<script setup lang="ts">
import ElevatedBlockBtn from '../ui-elements/buttons/ElevatedBlockBtn.vue';

defineProps<{
  title?: string
  message?: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>
<template>
  <v-card class="rounded-lg pa-10">
    <v-card-title class="d-flex flex-column align-center text-center font-weight-bold">
      <v-icon color="pwt_green" size="50">mdi-check-circle-outline</v-icon>
      <span>{{ title || 'Success' }} </span>
    </v-card-title>
    <v-card-text class="text-center">
      {{ message || 'Your request was processed successfully.' }}
    </v-card-text>
    <v-card-actions class="justify-center">
      <ElevatedBlockBtn @click="emit('close')" class="mt-4" shape="box"> Ok </ElevatedBlockBtn>
    </v-card-actions>
  </v-card>
</template>
